import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {TdoDropdownModel} from './models/tdo-dropdown.model';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'tdo-basic-dropdown',
  templateUrl: './tdo-basic-dropdown.component.html',
  styleUrls: ['./tdo-basic-dropdown.component.scss']
})
export class TdoBasicDropdownComponent implements OnInit {
  @Input() placeholder: string;
  @Input() dataSet: TdoDropdownModel[] = [];
  @Input() value: TdoDropdownModel;
  @Input() zIndex = 100;
  // Clamp can currently be right; (clamp = right)
  @Input() clamp: string;

  @Input() width = '150px';
  @Input() height = '40px';
  @Input() dropDownWidth = '150px';
  @Input() dropDownHeight = '200px';
  @Input() dropdownYOffset = 0;
  @Input() dropdownXOffset = 0;
  @Output() itemSelected = new EventEmitter<TdoDropdownModel>();

  isShowMenu = false;

  constructor() { }

  ngOnInit(): void {
    if (this.value) {
      this.placeholder = this.value.label;
    }

    switch (this.clamp)
    {
      case 'right':
        const width = this.width.substr(0, this.width.length - 2);
        this.dropdownXOffset = parseInt(width);
        break;
    }
  }

  onDropDownButtonClick(): void {
    this.isShowMenu = !this.isShowMenu;
    if (this.isShowMenu) {
      this.zIndex = 4000;
    } else {
      this.zIndex = 1000;
    }
  }

  onItemSelected(model: TdoDropdownModel): void {
    this.isShowMenu = false;
    this.placeholder = model.label;
    this.value = model;
    this.itemSelected.emit(model);
  }

  onClickOutside() {
    if (this.isShowMenu) {
      this.isShowMenu = false;
    }
  }
}
